"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _TagsFormField = require("./TagsFormField.styles");
var _FormField = require("../../lib/FormField");
var _theme = require("../utils/theme");
var _Text = require("../Text");
var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var TagsFormField = function TagsFormField(_ref) {
  var initialValue = _ref.initialValue,
    label = _ref.label,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var _useState = (0, _react.useState)(initialValue !== null && initialValue !== void 0 ? initialValue : []),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    values = _useState2[0],
    setValues = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    currentValue = _useState4[0],
    setCurrentValue = _useState4[1];
  function enterKeyPress(e) {
    if ((e.keyCode == 9 || e.keyCode == 13) && currentValue) {
      var newValues = [].concat((0, _toConsumableArray2["default"])(values), [e.target.value]);
      if (values.indexOf(e.target.value) < 0) {
        setValues(newValues);
        if (onChange) {
          onChange(newValues);
        }
      }
      setCurrentValue('');
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_TagsFormField.TagsFormFieldContainer, null, /*#__PURE__*/_react["default"].createElement(_FormField.FormField, {
    label: label,
    placeholder: placeholder,
    onChange: function onChange(value) {
      setCurrentValue(value);
    },
    onKeyDown: enterKeyPress,
    value: currentValue,
    disabled: disabled
  }), /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    type: "small",
    color: _theme.defaultTheme.color.gray
  }, "Press enter or tab after each reason."), /*#__PURE__*/_react["default"].createElement(_TagsFormField.TagsCard, null, values.map(function (value) {
    return /*#__PURE__*/_react["default"].createElement(_TagsFormField.TagCard, null, /*#__PURE__*/_react["default"].createElement(_Text.Text, {
      type: "small",
      color: _theme.defaultTheme.color.primary["default"]
    }, value), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      dense: true,
      format: "round",
      size: "10",
      icon: "close",
      colored: true,
      color: "white",
      containerColor: _theme.defaultTheme.color.primary["default"],
      onClick: function onClick() {
        var newValues = values.filter(function (item) {
          return item !== value;
        });
        setValues(newValues);
        if (onChange) {
          onChange(newValues);
        }
      }
    }));
  })));
};
var _default = exports["default"] = TagsFormField;